"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ESC = exports.ENTER = void 0;
var ESC = exports.ESC = 27;
var ENTER = exports.ENTER = 13;